import { Organization, Filial } from './types';

interface Result {
  name: string;
  title: string;
  coords: Array<number>;
  location: string;
}

type Point = Organization | Filial;
type Points = Array<Point>;
type Output = Array<Result>;

export const getPoints = (points: Points): Output => {
  return points.reduce((sum: Output, item: Point) => {
    const { name, coords, contacts: { address = '' } } = item;
    if (!coords) return sum;

    let { latitude = null, longitude = null } = coords || {};
    if (latitude === null || longitude === null) return sum;

    sum.push({
      name,
      location: address,
      title: name,
      coords: [
        typeof latitude === 'string' ? parseFloat(latitude) : latitude,
        typeof longitude === 'string' ? parseFloat(longitude) : longitude,
      ],
    });
    return sum;
  }, [] as Output);
}



// WEBPACK FOOTER //
// ./src/pages/organizations/map/tools.ts